export const feedbackStrings = {
  noFeedback: "No feedback available",
};
